import * as React from 'react';

export const ImageLoadingContext = React.createContext({lazyload: true});
